import {createAction, handleActions} from 'redux-actions';
import axios from 'axios/index';
import * as _ from 'lodash';

import {
  setCarID,
  setCarBrand,
  setCarModel,
  setCarSize,
  setCarType,
  setCarDetail,
  setPartBy,
  updateCar,
} from './CarReducer';
import {setDamageLoading} from './LoadingReducer';

const parseDamageData = (damageData) => {
  const data = _.map(damageData.damagelist, (item) => {
    if (item.wage_cost > 0) {
      item.wage_flag = 1;
    }
    if (item.part_cost > 0) {
      item.parts_flag = 1;
    }

    if (item.paint_flag == 1 || item.fix_flag == 1 || item.wage_flag == 1) {
      item.discount_wage_cost = item.discount_amount;
      item.discount_wage_percent = item.discount_percent;
      item.net_wage_cost = item.wage_cost;
      item.wage_quantity = item.quantity;
      item.wage_price_per_unit = item.price_per_unit;

      // if (item.price_per_unit <= 0 && item.wage_cost > 0) {
      //   item.wage_cost = item.wage_cost;
      // } else {
      //   item.wage_cost = item.price_per_unit;
      // }
    }
    if (item.part_flag == 1 || item.stock_flag == 1 || item.parts_flag == 1) {
      item.discount_part_cost = item.discount_amount;
      item.discount_part_percent = item.discount_percent;
      item.net_part_cost = item.part_cost;
      item.part_quantity = item.quantity;
      item.part_price_per_unit = item.price_per_unit;

      // if (item.price_per_unit <= 0 && item.part_cost > 0) {
      //   item.part_cost = item.part_cost;
      // } else {
      //   item.part_cost = item.price_per_unit;
      // }
    }
    return item;
  });

  return data || [];
};

export const updateDamageItemByRowIndex = createAction(
    'UPDATE_DAMAGE_ITEM_BY_ROW_INDEX');
export const removeDamageItemByRowIndex = createAction(
    'REMOVE_DAMAGE_ITEM_BY_ROW_INDEX');
export const updateDamageItemByWageItem = createAction(
    'UPDATE_DAMAGE_ITEM_BY_WAGE_ITEM');
export const updateDamageItemByPartItem = createAction(
    'UPDATE_DAMAGE_ITEM_BY_PART_ITEM');
export const addDamageItem = createAction('ADD_DAMAGE_ITEM');

export const setDamageList = createAction('SET_DAMAGE_LIST');


export const loadDamageData = (action = {}) => (dispatch, getState) => {
  const {wo} = action;
  // const wo = 'KKC.0767/2561';
  dispatch(setDamageLoading({loading: true}));
  axios.get(
      `/workdoc/damage?wo=${wo}&format=json`).
      then((response) => {
        const damageData = response.data && response.data.data || {};

        const damageList = parseDamageData(damageData);
        dispatch(setDamageList({
          data: damageList,
          payload: action,
        }));

        dispatch(setCarID({carID: damageData.car_cat_id}));
        dispatch(setCarBrand({carBrand: damageData.car_brand}));
        dispatch(setCarModel({carModel: damageData.car_model}));
        dispatch(setCarSize({carSize: damageData.car_size}));
        dispatch(setCarType({carType: damageData.car_type}));
        dispatch(setCarDetail({carDetail: damageData.car_detail}));
        dispatch(setPartBy({partBy: damageData.part_by}));
        dispatch(setDamageLoading({loading: false}));
        dispatch(updateCar({
          discount_part_cost: damageData.discount_part,
          discount_wage_cost: damageData.discount_wage,
        }));
      }).
      catch((error) => {
        // console.error(error);
      });
};

export const DamageReducer = (defaultState) => handleActions({
  loadDamageData,
  [setDamageList](state, action = {}) {
    const {data, payload} = action.payload || {};
    // console.log(action);
    return data || [];
  },
  [updateDamageItemByRowIndex](state, action = {}) {
    const {row, updated} = action.payload || {};
    let newState = [...state];
    newState[row] = {
      ...newState[row],
      ...updated,
    };
    newState[row] = calculation(newState[row], updated);
    return newState;
  },
  [updateDamageItemByWageItem](state, action = {}) {
    const {itemnum, updated} = action.payload || {};
    let newState = [...state];
    let updateItem = _.find(newState,
        damageItem => itemnum == damageItem.wage_itemnum);

    if (updateItem) {
      _.merge(updateItem, updated);

      newState = checkRejectItem(newState, updateItem);
    } else {
      const newItem = {
        ...updated,
        quantity: 1,
        prefer_repair: 1,
      };
      newState = addDamageWithItem(state, newItem);
    }

    return newState;
  },
  [updateDamageItemByPartItem](state, action = {}) {
    const {itemnum, updated} = action.payload || {};
    let newState = [...state];
    let updateItem = _.find(newState,
        damageItem => itemnum == damageItem.itemnum);

    if (updateItem) {
      _.merge(updateItem, updated);

      newState = checkRejectItem(newState, updateItem);
    } else {
      const newItem = {
        ...updated,
        quantity: 1,
        prefer_repair: 1,
      };
      newState = addDamageWithItem(state, newItem);
    }

    return newState;
  },
  [addDamageItem](state, action = {}) {
    const {amount, item} = action.payload || {};
    let newState = addDamageWithItem(state, item, amount);
    return newState;
  },
  [removeDamageItemByRowIndex](state, action = {}) {
    const {row, updated} = action.payload || {};
    const newState = [
      ...state.slice(0, row),
      ...state.slice(row + 1),
    ].map((item, index) => ({
      ...item,
      seq: index + 1,
    }));
    return newState;
  },
}, defaultState);

function addDamageWithItem(state, item, amount = 1) {
  let newState = [...state];

  for (let i = 1; i <= amount; i++) {
    const emptyRowIndex = getEmptyRowIndex(newState);
    if (emptyRowIndex === false || !item || !item.detail) {
      let lastSeq = (newState[newState.length - 1] || {}).seq || 0;
      newState.push({...item, seq: parseInt(lastSeq) + 1});
    } else {
      // console.log('before', newState);
      newState = [
        ...newState.slice(0, emptyRowIndex),
        {
          seq: newState[emptyRowIndex].seq,
          ...item,
        },
        ...newState.slice(emptyRowIndex + 1),
      ];

      // console.log('after', newState);
    }
  }

  return newState;
}

function getEmptyRowIndex(state) {
  const check_empty_fields = [
    'detail',
    'paint_flag',
    'fix_flag',
    'part_flag',
    'stock_flag',
    'quantity',
    'wage_cost',
    'part_cost'];

  for (let i in state) {
    if (_.every(_.pick(state[i], check_empty_fields), item => !item)) {
      return parseInt(i);
    }
  }

  return false;
}

function checkRejectItem(state, updateItem) {
  if (updateItem.fix_flag != 1
      && updateItem.paint_flag != 1
      && updateItem.part_flag != 1
      // && updateItem.stock_flag != 1
  ) {
    state = _.reject(state, updateItem);
  }

  return state;
}

function calculation(item, updated) {
  // item.discount_part_percent = item.discount_part_percent || 0;
  // item.discount_part_cost = item.discount_part_cost || 0;
  // item.discount_wage_percent = item.discount_wage_percent || 0;
  // item.discount_wage_cost = item.discount_wage_cost || 0;
  // item.net_wage_cost = item.net_wage_cost || item.wage_cost;
  // item.net_part_cost = item.net_part_cost || item.part_cost;
  // item.quantity = item.quantity || 1;
  if (item.part_flag == 1 || item.stock_flag == 1 || item.parts_flag) { 
    // const total_part_cost = (parseFloat(item.part_cost) *
    //                          parseFloat(item.quantity));
    const total_part_cost = (parseFloat(item.price_per_unit) *
                             parseFloat(item.quantity));

    if (!_.isUndefined(updated['discount_part_percent'])) {
      item.last_part_discount = 'percent';
    } else if (!_.isUndefined(updated['discount_part_cost'])) {
      item.last_part_discount = 'cost';
    }
    
    if (item.last_part_discount == 'cost') { 
      let zero = 0
      if (total_part_cost>0)
        item.discount_part_percent = ((parseFloat(item.discount_part_cost) / total_part_cost * 100) || 0).toFixed(2);
      else 
        item.discount_part_percent = zero.toFixed(2);
    } else {
      item.discount_part_cost = ((parseFloat(item.discount_part_percent)
                                  * total_part_cost) / 100) || 0;
    }

    if (!_.isUndefined(updated['net_part_cost'])) {
      item.part_cost = parseFloat(item.net_part_cost) / (item.quantity);
    } else {
      item.net_part_cost = (total_part_cost - item.discount_part_cost) ||
                           total_part_cost;
    }
  }

  if (item.paint_flag == 1 || item.fix_flag == 1 || item.wage_flag == 1 || item.wage_cost>0) {
    // const wage_cost = parseFloat(item.wage_cost) *
    //                   parseFloat(item.quantity);
    const wage_cost = parseFloat(item.wage_cost);
    if (!_.isUndefined(updated['discount_wage_percent'])) {
      item.last_wage_discount = 'percent';
    } else if (!_.isUndefined(updated['discount_wage_cost'])) {
      item.last_wage_discount = 'cost';
    }

    if (item.last_wage_discount == 'cost') {
      item.discount_wage_percent =
          ((parseFloat(item.discount_wage_cost) / wage_cost * 100) ||
           0).toFixed(2);     
    } else {
      item.discount_wage_cost = ((parseFloat(item.discount_wage_percent)
                                  * wage_cost) / 100) || 0;
    }
    if (!_.isUndefined(updated['net_wage_cost'])) {
      item.wage_cost = parseFloat(item.net_wage_cost) / (item.quantity);
    } else {
      item.net_wage_cost = (wage_cost - item.discount_wage_cost) ||
                           wage_cost;
    }
  }

  return item;
}

export default DamageReducer;


// WEBPACK FOOTER //
// ./src/stores/CarDamage/DamageReducer.js